import React from 'react';
import { Col, Container, Row } from "react-bootstrap";
import Img1 from "../../../images/case-studies/mdrouz/mission_girl.png";
import Img3 from "../../../images/case-studies/mdrouz/20_off.png";
import Img4 from "../../../images/case-studies/mdrouz/misson_mob.png";
import BgImg1 from "../../../images/case-studies/mdrouz/flower.png";
import { LazyLoadImage } from "react-lazy-load-image-component";

const Missioncase = () => {
    return (
        <div className="mission_case p-100" style={{ backgroundImage: `url(${BgImg1})` }}>
            <Container>
                <Row>
                    <Col xs={12} md={12} lg={3} xl={3} xxl={3} >
                        <h2><span>Mission</span></h2>
                        <p>Our mission was to design and develop Mdrouz, a state-of-the-art multi-vendor e-commerce app, to redefine the online shopping experience for users in the GCC region. </p>
                    </Col>
                    <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                        <div className="mission_box">
                            <div className="mission_content">
                                <p>The goal was to provide a platform that not only met but exceeded user expectations, offering a seamless blend of functionality, aesthetics, and local market relevance.</p>
                            </div>
                            <div className="mission_img">
                                <LazyLoadImage
                                    src={Img1}
                                    effect="blur" alt="TekRevol" className="img-fluid"
                                />
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={3} xl={3} xxl={3}>
                        <div className="mission_box1">
                            <div className="mission_content">
                                <div className="head_box">
                                    <span>Cancel</span>
                                    <h6>Sort</h6>
                                </div>
                                <ul>
                                    <li>Popular products</li>
                                    <li>Newly added</li>
                                    <li>Price (low to high)</li>
                                    <li>Price (high to low)</li>
                                </ul>
                            </div>
                        </div>
                        <div className="mission_img_1">
                            <LazyLoadImage
                                src={Img3}
                                effect="blur" alt="TekRevol" className="img-fluid"
                            />
                        </div>
                    </Col>
                    <Col xs={12} md={12} lg={3} xl={3} xxl={3}>
                        <div className="mission_mob_img">
                            <LazyLoadImage
                                src={Img4}
                                effect="blur" alt="TekRevol" className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}

export default Missioncase